<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                                <h6 class="mb-2 ms-2">Reporte para REPSE del {{ formatDate(startDate) }} al {{
                                    formatDate(endDate) }}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="mb-3 row">
                            <div class="col-md-3">
                                <label>Buscar:</label>
                                <input type="text" v-model="searchQuery" class="form-control"
                                    placeholder="Nombre del colaborador ..." />
                            </div>
                            <div class="col-md-1">
                                <label>Autorizado?:</label>
                                <div class="d-flex justify-conten-start">
                                    <div class="form-check form-switch mt-2 ms-1">
                                        <input @change="getData" v-model="onlyAuth" class="mt-1 form-check-input"
                                            type="checkbox" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <label>Fecha de inicio:</label>
                                <input type="date" v-model="startDate" class="form-control" />
                            </div>
                            <div class="col-md-2">
                                <label>Fecha de fin:</label>
                                <input type="date" v-model="endDate" class="form-control" />
                            </div>
                            <div class="col-md-2 d-flex align-items-end mt-2">
                                <button @click="getData" class="btn btn-secondary w-100"
                                    style="margin-bottom: 0px;">Cargar
                                    Fechas</button>
                            </div>
                            <div class="col-md-2 d-flex align-items-end mt-2">
                                <button @click="downloadReport" class="btn btn-warning w-100"
                                    style="margin-bottom: 0px;">
                                    Descargar Reporte</button>
                            </div>
                        </div>
                        <div v-if="!isLoaded">Cargando datos...</div>
                        <div v-if="isLoaded" class="table-responsive mt-4">
                            <table class="table table-bordered text-center align-middle">
                                <thead>
                                    <tr>
                                        <th>Colaborador</th>
                                        <th colspan="2">Total de horas</th>
                                        <th colspan="2">Total REPSE</th>
                                        <th colspan="2" v-for="client in allClients" :key="client.id"
                                            :style="{ backgroundColor: client.color }" style="color: white;">
                                            {{ client.name }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="emp in filteredRows" :key="emp.name">
                                        <!-- Resumen de horas -->
                                        <td><strong>{{ emp.full_name }}</strong></td>
                                        <td>{{ emp.total_hours.toFixed(2) }} hrs</td>
                                        <td><strong>100.0%</strong></td>
                                        <td>{{ emp.total_repse_hours.toFixed(2) }} hrs</td>
                                        <td><strong> {{ ((emp.total_repse_hours * 100) / emp.total_hours).toFixed(1) }}
                                                % </strong></td>
                                        <!-- Columnas dinámicas por cliente -->
                                        <template v-for="client in allClients" :key="'client-' + client.id">
                                            <td style="text-align:center">
                                                <template v-if="getClientData(emp.percentage, client.id)">
                                                    {{ getClientData(emp.percentage, client.id).hours.toFixed(2) }} hrs
                                                    <i class="bi bi-question-circle text-muted" role="button"
                                                        @click="getClientUserData(emp.user_id, emp.full_name, getClientData(emp.percentage, client.id).hours.toFixed(2), client.id, client.name)">
                                                    </i>
                                                </template>
                                                <template v-else><strong>- - -</strong></template>
                                            </td>
                                            <td style="text-align:center">
                                                <template v-if="getClientData(emp.percentage, client.id)">
                                                    <strong>
                                                        {{ getClientData(emp.percentage,
                                                            client.id).percentage.toFixed(1)
                                                        }}%
                                                    </strong>
                                                </template>
                                                <template v-else><strong>- - -</strong></template>
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalXL :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData" @close="closeModal">
    </ModalXL>
</template>
<script setup>

import { onMounted, ref, computed, shallowRef } from "vue"
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

// Controladores de Modal
import ModalXL from "./components/ModalXL.vue";
import ClientUserRepseDetails from "./components/forms/ClientUserRepseDetails.vue";
const isModalOpen = ref(false);
const selectedFormComponent = shallowRef(null);
const modalTitle = ref("Detalles de tiempos de REPSE");
const selectedData = ref(null)

const formComponents = {
    ClientUserRepseDetails: ClientUserRepseDetails,
}

// Función para abrir el modal con un formulario y datos específicos
const openModal = (data, formType) => {
    selectedData.value = data || {}; // Si no se pasa nada, se inicializa como objeto vacío
    selectedFormComponent.value = formComponents[formType] || null;
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};


// Fecha de fin el dia de hoy
const endDate = ref(new Date().toISOString().split('T')[0]);
// Fecha de inicio hace un mes
const start = new Date();
start.setMonth(start.getMonth() - 1);
const startDate = ref(start.toISOString().split('T')[0]);

const rows = ref([])
const allClients = ref([])
const searchQuery = ref('')

const onlyAuth = ref(false)
const isLoaded = ref(false)

const filteredRows = computed(() => {
    const query = searchQuery.value.toLowerCase();
    return rows.value.filter(row =>
        (row.full_name?.toLowerCase().includes(query))
    );
});

const getClientData = (percentageArr, client_id) => {
    return percentageArr.find(c => Number(c.client_id) === Number(client_id)) || null
}

const getClientUserData = async (userId, userName, totalClientHours, clientId, clientName) => {

    const data = {
        user_id: userId,
        client_id: clientId,
        start_date: startDate.value,
        end_date: endDate.value,
        only_auth: onlyAuth.value,
        user_name: userName,
        client_name: clientName,
        total_client_hours: totalClientHours,
    }
    openModal(data, 'ClientUserRepseDetails')

}

const getData = async () => {

    const body = {
        start_date: startDate.value,
        end_date: endDate.value,
        only_auth: onlyAuth.value,
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/get-repse-report`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        rows.value = response.data.data; // Asigna los datos a variable `reportData`
        console.log(rows.value)
        // Construir columnas únicas
        const clientsSet = new Map();
        rows.value.forEach(emp => {
            emp.percentage.forEach(c => {
                clientsSet.set(c.client_id, { name: c.client, color: c.color });
            });
        });
        allClients.value = Array.from(clientsSet, ([id, info]) => ({ id, ...info }));
        console.log(allClients.value)
        isLoaded.value = true
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const downloadReport = async () => {

    const body = {
        start_date: startDate.value,
        end_date: endDate.value,
        only_auth: onlyAuth.value,
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/download-repse-report`, body, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reporte-repse.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
        console.error('Error al descargar el reporte:', err);
    }
};

const formatDate = (date) => {
    if (!date) return '';

    const d = new Date(date + 'T00:00:00'); // <-- Fuerza hora local
    if (isNaN(d.getTime())) return '';

    return d.toLocaleDateString('es-ES', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
}

// Inicializa el DataTable después de obtener los datos
onMounted(async () => {
    await getData()
});


</script>